import script from "./SeleccionPeleador.vue?vue&type=script&setup=true&lang=js"
export * from "./SeleccionPeleador.vue?vue&type=script&setup=true&lang=js"

import "./SeleccionPeleador.vue?vue&type=style&index=0&id=761bafe0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761bafe0"]])

export default __exports__